import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { _Api } from "../common/api/_call";
import { Tablehead } from "../../components/common/modules/Tablehead";
import { posquotationlist_head } from "../../components/common/Tablehead";
import CheckoutBlank from "../checkout/checkoutBlank";
import { SetdataTable, UnSetdataTable } from "../common/api/setdatatable";
import { toFormatPrice } from '../common/helpers/function';
import { useTranslation } from 'react-i18next';
import { Quotationsubtable } from "./subtable/Quotationsubtable";
import $ from 'jquery';
import CheckoutSell from '../checkout/checkoutSell'
import CheckoutPayment from '../checkout/checkoutPayment'
import Select from "react-select";
const QuotationList = () => {
  const navigate = useNavigate();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const { t } = useTranslation();
  const [newcolumndata, setnewcolumndata] = useState(posquotationlist_head)
  const [quotationlist, setQuotationlist] = useState([])
  const [, setSelectAllStatus] = useState();
  const [quotationid, setQuotationid] = useState()
  const [showcheckout, setShowcheckout] = useState('blank')
  const [, setdeletestatus] = useState(false)
  const [UpdatedCart, setUpdatedCart] = useState();
  const [showpayment, setShowpayment] = useState(false);
  const [searchproductstatus, setsearchproductstatus] = useState(false);
  const [, setfilterby] = useState("");
  const [excuteTable, setexcuteTable] = useState(false);
  const [filtername, setFiltername] = useState("");
  const [limit, setLimit] = useState(100);
  useEffect(() => {
    callcolumns();
  }, []);
  const callcolumns = async () => {
    try {
      const postdata = {
        name: "tbl_pos_customerlist",
      };
      let columnhead = await _Api(
        postdata,
        `api/v1/Inventory/common/getColumnHeads`
      );
      if (columnhead.code === 200) {
        setnewcolumndata(columnhead?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };


  const getquotationlist = async (firstlimit) => {
    setexcuteTable(false);
    UnSetdataTable('quotaion_list_table')
    try {
      setTimeout(async function () {
        let postdata = {
          "search": filtername,
          "limit": firstlimit ? firstlimit : limit,
        }
        const res = await _Api(postdata, `api/v1/POS/quatation/getQuatationList`)
        if (res.code === 200) {
          setexcuteTable(true);
          setQuotationlist(res.data);
          SetdataTable('quotaion_list_table', 0)
        }
        else {
          SetdataTable('quotaion_list_table', 0)
        }
      }, 100)
    }
    catch (err) {
      console.log(err, "err");
    }
  }
  useEffect(() => {
    getquotationlist()
    // eslint-disable-next-line
  }, [newcolumndata])
  const setSubTablequotation = async (id) => {
    var e = document.querySelector("#table-btn_" + id);
    var row = document.querySelector('#common-main-table-wrap-' + id);
    var classList_ = e.classList;

    if (classList_.contains("rotate-90")) {
      classList_.remove("rotate-90");
      let alllist_data = [...quotationlist];
      alllist_data.filter(item => item.id === id).forEach((result) => {
        result.subTabledata = null
      })
      setQuotationlist(alllist_data);

    } else {
      classList_.add("rotate-90");
      let alllist_data = [...quotationlist];
      const postdata = {
        "quatation_id": id
      };
      let prioritydata = await _Api(postdata, `api/v1/POS/quatation/getQuatationSubList`);
      var html_ = Quotationsubtable(prioritydata, id, t);
      alllist_data.filter(item => item.id === id).forEach((result) => {
        result.subTabledata = html_
      })
      setQuotationlist(alllist_data);
      var checkRowSub = setInterval(function () {
        var rowSub = document.querySelector('#common-sub-table-wrap-' + id);
        if (rowSub) {
          $(row).after(rowSub);
          clearInterval(checkRowSub);
        }
      }, 100);

    }
  }
  const GetCartdetailorder = async () => {
    try {
      const postdata = {
        "quatation_id": quotationid
      }
      let res = await _Api(postdata, `api/v1/POS/customOrder/getCartItems`)
      if (res.code === 200) {
        setUpdatedCart(res?.data);
        setShowcheckout('sell');
      } else {
        navigate('/app/pos/custom/customOrderDelivered')
      }
    } catch (err) {
      console.log(err, 'err')
    }
  }
  const removequotation = async () => {
    try {
      let postdata = {
        "quatation_id": quotationid
      }
      let res = await _Api(postdata, `api/v1/POS/quatation/removeQuatation`)
      if (res.code === 200) {
        getquotationlist()
      }

    }
    catch (err) {
      console.log(err, 'err')
    }
  }
  const filterbyname = () => {
    if (filtername) {
      getquotationlist();
    } else {
      getquotationlist();
    }
  };
  const selectOptions = [
    { label: 100, value: 100 },
    { label: 200, value: 200 },
    { label: 300, value: 300 }
  ]
  return (
    <>
      <div className="main-body">
        <div className="main-body-row">
          <div className="main-body-row-left-col p-0">
            <div className="customer com-data-area">
              <div className='customer-inner com-data-area-inner'>
                <div className="catalog-area-header-area detail-area-header">
                  <div className="catalog-area-header-area-control">
                    <div className="catalog-area-header-area-control-left page-back-btn-inside">
                      <Link to="/app/pos/custom/custom"><img className='page-back-btn-inside-img' src={base_assets + "/images/icons/arrow-left.png"} alt="back" /></Link>
                      <h1 className="heading">{t("Quotation list")}</h1>
                    </div>

                    <div className="catalog-area-header-area-control-right">
                      <div className="com-search-area">
                        <button className="com-search-area-left-img scan-img"><img src={base_assets + "/images/pos/icons/scan-icon.png"} alt="" /></button>
                        <input type="text" placeholder={t("Scan barcode, Search SKU")}
                          onKeyPress={(e) => e.key === 'Enter' && filterbyname()}
                          onChange={(e) => setFiltername(e.target.value)} />
                        <button className="btn-style lh-0">
                          <img className="com-search-area-img" src={base_assets + "/images/pos/icons/magnifying-glass.png"} alt=""
                            onClick={filterbyname} />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="customer-inner-data com-data-area-inner">
                  <div className='search'>
                    <div className='search-custom d-flex align-items-center'>
                      <span className='title'>{t("Show")}:</span>
                      <Select
                        className="limit-select short mx-3 z-10"
                        options={selectOptions}
                        value={{ label: limit, value: limit }}
                        onChange={(e) => { setLimit(e.value); getquotationlist(e.value) }}
                      />
                    </div>
                    <div className='data-set'>
                    </div>
                  </div>
                  <div className="main-body-main-table-wrap  vertical-scroll-table">
                    <table id="quotaion_list_table" className="common-table first-row-gray w-100">
                      <Tablehead
                        tablehead={posquotationlist_head}
                        tblname={'tbl_pos_customerlist'}
                        setShowoption={setSelectAllStatus}
                        setfilterby={setfilterby}
                      />
                      <tbody>
                        <>
                          {quotationlist.length ? quotationlist.map((result, key) => {
                            return (
                              <React.Fragment key={key}>
                                <tr id={`common-main-table-wrap-${result?.id}`} key={result?.id} onClick={() => setQuotationid(result?.id)}>
                                  <td>{key + 1}</td>
                                  <td>{result?.date ? result?.date : "-"}</td>
                                  <td>{result?.type ? result?.type : "-"}</td>
                                  <td className="link-color">{result?.quo_no ? result?.quo_no : "-"}</td>
                                  <td className="link-color sku-col table_btn_expand_col"
                                    onClick={() => setSubTablequotation(result?.id)}
                                    id={"table-btn_" + result?.id}
                                  >
                                    <img
                                      className="sku-col-arrow cursor-pointer"
                                      src={
                                        base_assets +
                                        "/images/icons/right_green_button.png"
                                      }
                                      alt=""
                                    />{result?.SKU ? result?.SKU : "-"}</td>
                                  <td>{result?.customer ? result?.customer : "-"}</td>
                                  <td>{result?.location ? result?.location : "-"}</td>
                                  <td>{result?.qty ? result?.qty : "-"}</td>
                                  <td>{toFormatPrice(result?.amount, { addSymbol: true })}</td>
                                  <td>
                                    <div className="customer-table-dropdown dropdown">
                                      <button className='btn-style dropdown-toggle' type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"><img src={base_assets + 'images/icons/ellipsis-circular.png'} alt="" /></button>
                                      <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <li onClick={() => GetCartdetailorder()}>
                                          <Link className="dropdown-item img-btn-hover svg-stroke-hover" >
                                            <div className="dropdown-menu-img">
                                              <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10.5 13.5H5.5M8 16V11" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M1 18V2C1 1.73478 1.10536 1.48043 1.29289 1.29289C1.48043 1.10536 1.73478 1 2 1H8.172C8.70239 1.00011 9.21101 1.2109 9.586 1.586L14.414 6.414C14.7891 6.78899 14.9999 7.29761 15 7.828V18C15 18.2652 14.8946 18.5196 14.7071 18.7071C14.5196 18.8946 14.2652 19 14 19H2C1.73478 19 1.48043 18.8946 1.29289 18.7071C1.10536 18.5196 1 18.2652 1 18Z" stroke="black" strokeWidth="2" strokeLinejoin="round" />
                                                <path d="M8 1V7C8 7.26522 8.10536 7.51957 8.29289 7.70711C8.48043 7.89464 8.73478 8 9 8H15" stroke="black" strokeWidth="2" strokeLinejoin="round" />
                                              </svg>
                                            </div>
                                            {t("Add to Order")}</Link>
                                        </li>
                                        <li >
                                          <Link className="dropdown-item img-btn-hover svg-stroke-hover" >
                                            <div className="dropdown-menu-img">
                                              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M6.26389 0.917969H15.7361C16.2434 0.917936 16.7315 1.11203 17.1003 1.46043C17.469 1.80884 17.6904 2.28514 17.7192 2.79164L17.7222 2.90408V4.58402L18.7917 4.58464C20.5639 4.58464 22 6.02075 22 7.79297V16.043C22 16.5697 21.7907 17.0749 21.4183 17.4474C21.0458 17.8198 20.5406 18.0291 20.0139 18.0291L17.7222 18.0285V19.0985C17.7222 19.6253 17.513 20.1304 17.1405 20.5029C16.768 20.8754 16.2629 21.0846 15.7361 21.0846H6.26389C5.73714 21.0846 5.23196 20.8754 4.8595 20.5029C4.48703 20.1304 4.27778 19.6253 4.27778 19.0985V18.0285L1.98611 18.0291C1.45936 18.0291 0.954186 17.8198 0.581718 17.4474C0.20925 17.0749 0 16.5697 0 16.043V7.79297C0 6.02075 1.43611 4.58464 3.20833 4.58464L4.27778 4.58402V2.90408C4.27774 2.39677 4.47184 1.90868 4.82024 1.53994C5.16865 1.17119 5.64495 0.949746 6.15144 0.921024L6.26389 0.917969ZM15.7361 13.4457H6.26389C6.14233 13.4457 6.02575 13.494 5.9398 13.58C5.85384 13.6659 5.80556 13.7825 5.80556 13.9041V19.0985C5.80556 19.3515 6.01089 19.5569 6.26389 19.5569H15.7361C15.8577 19.5569 15.9742 19.5086 16.0602 19.4226C16.1462 19.3367 16.1944 19.2201 16.1944 19.0985V13.9041C16.1944 13.7825 16.1462 13.6659 16.0602 13.58C15.9742 13.494 15.8577 13.4457 15.7361 13.4457ZM18.7917 6.11241H3.20833C2.76262 6.11241 2.33517 6.28947 2.02 6.60464C1.70484 6.9198 1.52778 7.34726 1.52778 7.79297V16.043C1.52778 16.296 1.73311 16.5013 1.98611 16.5013L4.27778 16.5007V13.9041C4.27778 13.3773 4.48703 12.8722 4.8595 12.4997C5.23196 12.1272 5.73714 11.918 6.26389 11.918H15.7361C16.2629 11.918 16.768 12.1272 17.1405 12.4997C17.513 12.8722 17.7222 13.3773 17.7222 13.9041V16.5007L20.0139 16.5013C20.1354 16.5013 20.252 16.453 20.338 16.3671C20.4239 16.2811 20.4722 16.1645 20.4722 16.043V7.79297C20.4722 7.34726 20.2952 6.9198 19.98 6.60464C19.6648 6.28947 19.2374 6.11241 18.7917 6.11241ZM15.7361 2.44575H6.26389C6.15313 2.44575 6.04612 2.48586 5.96265 2.55866C5.87918 2.63146 5.8249 2.73202 5.80983 2.84175L5.80556 2.90408V4.58402H16.1944V2.90408C16.1944 2.79332 16.1543 2.68632 16.0815 2.60284C16.0087 2.51937 15.9082 2.46509 15.7984 2.45002L15.7361 2.44575Z" fill="#2A2A2A" />
                                              </svg>

                                            </div>
                                            {t("print")}</Link>
                                        </li>
                                        <li onClick={() => removequotation()}>
                                          <Link className="dropdown-item img-btn-hover svg-fill-hover" >
                                            <div className="dropdown-menu-img">
                                              <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7.85603 4.14342H12.1417C12.1417 3.57509 11.916 3.03005 11.5141 2.62819C11.1122 2.22632 10.5672 2.00056 9.99888 2.00056C9.43056 2.00056 8.88552 2.22632 8.48365 2.62819C8.08179 3.03005 7.85603 3.57509 7.85603 4.14342ZM6.57031 4.14342C6.57031 3.2341 6.93154 2.36203 7.57452 1.71905C8.2175 1.07607 9.08957 0.714844 9.99888 0.714844C10.9082 0.714844 11.7803 1.07607 12.4232 1.71905C13.0662 2.36203 13.4275 3.2341 13.4275 4.14342H18.7846C18.9551 4.14342 19.1186 4.21114 19.2392 4.3317C19.3597 4.45226 19.4275 4.61578 19.4275 4.78627C19.4275 4.95677 19.3597 5.12028 19.2392 5.24084C19.1186 5.3614 18.9551 5.42913 18.7846 5.42913H17.6617L16.6186 17.946C16.5427 18.8566 16.1274 19.7053 15.455 20.3241C14.7827 20.9428 13.9023 21.2862 12.9886 21.2863H7.00917C6.09545 21.2862 5.21512 20.9428 4.54274 20.3241C3.87037 19.7053 3.45506 18.8566 3.37917 17.946L2.33603 5.42913H1.21317C1.04267 5.42913 0.87916 5.3614 0.758601 5.24084C0.638042 5.12028 0.570312 4.95677 0.570312 4.78627C0.570312 4.61578 0.638042 4.45226 0.758601 4.3317C0.87916 4.21114 1.04267 4.14342 1.21317 4.14342H6.57031ZM8.71317 9.07199C8.71317 8.90149 8.64544 8.73798 8.52488 8.61742C8.40432 8.49686 8.24081 8.42913 8.07031 8.42913C7.89982 8.42913 7.7363 8.49686 7.61574 8.61742C7.49519 8.73798 7.42746 8.90149 7.42746 9.07199V16.3577C7.42746 16.5282 7.49519 16.6917 7.61574 16.8123C7.7363 16.9328 7.89982 17.0006 8.07031 17.0006C8.24081 17.0006 8.40432 16.9328 8.52488 16.8123C8.64544 16.6917 8.71317 16.5282 8.71317 16.3577V9.07199ZM11.9275 8.42913C11.757 8.42913 11.5934 8.49686 11.4729 8.61742C11.3523 8.73798 11.2846 8.90149 11.2846 9.07199V16.3577C11.2846 16.5282 11.3523 16.6917 11.4729 16.8123C11.5934 16.9328 11.757 17.0006 11.9275 17.0006C12.098 17.0006 12.2615 16.9328 12.382 16.8123C12.5026 16.6917 12.5703 16.5282 12.5703 16.3577V9.07199C12.5703 8.90149 12.5026 8.73798 12.382 8.61742C12.2615 8.49686 12.098 8.42913 11.9275 8.42913Z" fill="black" />
                                              </svg>
                                            </div>
                                            {t("Delete")}</Link>
                                        </li>
                                      </ul>
                                    </div>
                                  </td>
                                </tr>

                                {
                                  excuteTable ? (
                                    <>
                                      {typeof result.subTabledata == "undefined" ? (result.subTabledata = "") : result.subTabledata}
                                    </>
                                  ) : null
                                }

                              </React.Fragment>
                            )
                          }) : ""}
                        </>

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="main-body-row-right-col">
            {showcheckout === 'sell' ? (
              <CheckoutSell
                setShowcheckout={setShowcheckout}
                setdeletestatus={setdeletestatus}
                setUpdatedCart={setUpdatedCart}
                UpdatedCart={UpdatedCart}
                setShowpayment={setShowpayment}
                showpayment={showpayment}
                setsearchproductstatus={setsearchproductstatus}
                searchproductstatus={searchproductstatus}
              // ordertype={"Quotation"}
              />
            ) : showcheckout === 'payment' ? (
              <CheckoutPayment UpdatedCart={UpdatedCart} setShowcheckout={setShowcheckout} quotationid={quotationid ? quotationid : ''} />
            ) : (
              <CheckoutBlank />
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default QuotationList;